import { useDoubleContractKlineStore, doubleMSocketService } from 'store'
import { SocketEventName } from 'store/src/socket/SocketService'
import { PLATFORM_CONFIG } from 'platform-config'
import { DepthChart } from 'ui-components'
import { useI18n } from 'i18n-utils'

export default defineComponent({
  name: 'Depth',
  setup() {
    const buyList = ref<SocketResponse.HandicapData[]>([]) // 订阅买盘数据
    const sellList = ref<SocketResponse.HandicapData[]>([])

    const { t } = useI18n()
    const { font } = PLATFORM_CONFIG
    const klineStore = useDoubleContractKlineStore()

    // 卖盘数据
    const sellListenHandicapCallback = (response: SocketResponse.HandicapResponse) => {
      const { a } = response.data
      sellList.value = a
      // 按照close进行降序
      sellList.value.sort((a, b) => b[0].subtractStr(a[0]).toNumber())
    }

    // 买盘数据
    const buyListenHandicapCallback = (response: SocketResponse.HandicapResponse) => {
      const { b } = response.data
      buyList.value = b
      // 按照close进行降序
      buyList.value.sort((a, b) => b[0].subtractStr(a[0]).toNumber())
    }

    onMounted(() => {
      doubleMSocketService.onMessage<SocketResponse.HandicapResponse>(SocketEventName.Handicap, buyListenHandicapCallback)

      doubleMSocketService.onMessage<SocketResponse.HandicapResponse>(SocketEventName.Handicap, sellListenHandicapCallback)
    })

    return () => (
      <DepthChart
        buyList={buyList.value}
        sellList={sellList.value}
        priceText={t('价格')}
        numText={t('数量')}
        family={font.family}
        lineColor="var(--colors-divider)"
        decimal={klineStore.coinFromPrecision}
        downColor="var(--colors-down)"
        upColor="var(--colors-up)"
      />
    )
  },
})
